import Marquee from "react-fast-marquee";
import { useSettings } from "@/contexts/SettingsContext";
import { resolveImage } from "@/lib/api";

const FALLBACK = [
  { name: "Amazon", url: "https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg" },
  { name: "Samsung", url: "https://upload.wikimedia.org/wikipedia/commons/2/24/Samsung_Logo.svg" },
  { name: "Coca-Cola", url: "https://upload.wikimedia.org/wikipedia/commons/c/ce/Coca-Cola_logo.svg" },
  { name: "Philips", url: "https://upload.wikimedia.org/wikipedia/commons/7/77/Philips_logo.svg" },
];

export default function ClientMarquee() {
  const { settings } = useSettings();
  const logos = (settings?.client_logos?.length ? settings.client_logos : FALLBACK).filter(
    (l) => l && l.url
  );

  if (!logos.length) return null;

  // Duplicate the list so the marquee loop feels seamless
  const loop = logos.concat(logos);

  return (
    <section className="border-t-2 border-b-2 border-ot-fg bg-ot-bg py-6" data-testid="client-marquee">
      <Marquee speed={55} gradient={false} pauseOnHover>
        {loop.map((l, i) => (
          <div
            key={`${l.name}-${i}`}
            className="mx-10 md:mx-14 h-12 md:h-14 flex items-center opacity-60 hover:opacity-100 transition-opacity grayscale hover:grayscale-0"
            title={l.name}
          >
            <img
              src={resolveImage(l.url)}
              alt={l.name}
              className="h-full max-h-12 md:max-h-14 object-contain"
              loading="lazy"
              onError={(e) => { e.currentTarget.style.display = "none"; }}
            />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
